// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__3vH7p","content":"style_content__1d18r","action":"style_action__3wkr_","select":"style_select__1igDe","inputs":"style_inputs__MlzBb"};